<template>
  <div class="badges">
    <span class="badge badge-green" v-if="newItems > 0">
      {{ newItems }}
    </span>

    <span class="badge badge-red" v-if="errorItems > 0">
      {{ errorItems }}
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newItems: 0,
      errorItems: 0,
    }
  },
  props: {
    procedimentos: {
      type: Array,
      default: [],
    },
    tab: {
      type: Object,
      default: {},
    },
    count: Boolean,
  },
  methods: {
    countItems() {
      this.countNewItems()
      this.countErrorItems()
    },

    countNewItems() {
      this.newItems = 0

      this.procedimentos.map((procedimento) => {
        const procedimentoBelongsToGroup = this.tab.groups.indexOf(procedimento.idTipoProcedimento) > -1

        if (procedimentoBelongsToGroup) {
          if (procedimento._isNew) {
            this.newItems = this.newItems + 1
          }
        }
      })
    },

    countErrorItems() {
      this.errorItems = 0

      this.procedimentos.map((procedimento) => {
        const procedimentoBelongsToGroup = this.tab.groups.indexOf(procedimento.idTipoProcedimento) > -1

        if (procedimentoBelongsToGroup) {
          if (procedimento._isError) {
            this.errorItems = this.errorItems + 1
          }
        }
      })
    },
  },
  watch: {
    count() {
      this.countItems()
    },
  },
}
</script>

<style lang="scss" scoped>
.badges {
  margin: 0 0 0 8px
}

.badge {
  border-radius: 50%;
  height: 22px;
  width: 22px;
  font-size: 13px;
  color: #FFF;
  padding: 4px 0;
}

.badge-green {
  background-color: #4caf50
}

.badge-red {
  background-color: #f44336
}
</style>
